var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 25.315,
    viewBox: "0 0 112 25.315",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5703",
    "data-name": "Group 5703",
    transform: "translate(-928 -160.463)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_888",
    "data-name": "Line 888",
    x2: 100,
    transform: "translate(936 181.778)",
    fill: "none",
    stroke: "#006dff",
    strokeWidth: 1,
    strokeDasharray: "1 2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_196",
    "data-name": "Ellipse 196",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(1032 177.778)",
    fill: "#006dff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_197",
    "data-name": "Ellipse 197",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(928 177.778)",
    fill: "#006dff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6597",
    "data-name": "Group 6597",
    transform: "translate(13053.779 1942.697)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4224",
    "data-name": "Rectangle 4224",
    width: 6.932,
    height: 9.677,
    transform: "translate(-12079.046 -1782.234)",
    fill: "#006dff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6598",
    "data-name": "Group 6598",
    transform: "translate(-12090.571 -1776.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36030",
    "data-name": "Path 36030",
    d: "M-12763.4-1384.6h-20.229l-3.85,4.145h-23.094l6.317,12.138,34.354-.018Z",
    transform: "translate(12810.571 1384.598)",
    fill: "#006dff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.8c9a4f3fc400e225dfa924ea5a0de618.svg";
export { ForwardRef as ReactComponent };